// @flow

export const fuzzySearch = (substr: string, string: string) => {
  const arr = substr
    .toLowerCase()
    .split('')
    .reverse()
  let tmp = arr.pop()

  string
    .toLowerCase()
    .split('')
    .forEach(elem => {
      if (elem === tmp) {
        tmp = arr.pop()
      }
    })

  return arr.length === 0 && typeof tmp === 'undefined'
}
